// extracted by mini-css-extract-plugin
export default {"rawPageLayoutWrapper":"RawPage_rawPageLayoutWrapper__sFS3x"};